export function dispatch(element, eventType, detail, eventInit = { bubbles: true }) {
    if (typeof Event !== 'undefined' && element) {
        const event = new CustomEvent(eventType, Object.assign(Object.assign({}, eventInit), { detail }));
        element === null || element === void 0 ? void 0 : element.dispatchEvent(event);
        return event;
    }
}
//# sourceMappingURL=dispatch.js.map